var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8,0H4A4,4,0,0,0,0,4V5A4,4,0,0,0,4,9H5v2H3a1,1,0,0,0,0,2H9a1,1,0,0,0,0-2H7V9H8a4,4,0,0,0,4-4V4A4,4,0,0,0,8,0Zm2,5A2,2,0,0,1,8,7H4A2,2,0,0,1,2,5V4A2,2,0,0,1,4,2H8a2,2,0,0,1,2,2Zm10,6H18a4,4,0,0,0-4,4v5a4,4,0,0,0,4,4h2a4,4,0,0,0,4-4V15A4,4,0,0,0,20,11Zm2,9a2,2,0,0,1-2,2H18a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2ZM14,4a1,1,0,0,1,1-1h2a3,3,0,0,1,3,3V8a1,1,0,0,1-2,0V6a1,1,0,0,0-1-1H15A1,1,0,0,1,14,4ZM12,20a1,1,0,0,1-1,1H8a3,3,0,0,1-3-3V16a1,1,0,0,1,2,0v2a1,1,0,0,0,1,1h3A1,1,0,0,1,12,20Zm8,0a1,1,0,1,1-1-1A1,1,0,0,1,20,20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.ca8a46dd.svg";
export { ForwardRef as ReactComponent };